import { render, staticRenderFns } from "./CustomerBuilderModal.vue?vue&type=template&id=3d679062&scoped=true&"
import script from "./CustomerBuilderModal.vue?vue&type=script&lang=js&"
export * from "./CustomerBuilderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d679062",
  null
  
)

export default component.exports